/* Refresh the legacy mini-cart only when its contents have changed. */
(function () {
  var busy = false;
  var pending = false;

  function refreshMiniCart() {
    // Other cart modes already refresh this section in theme.js.
    if (!window.theme || window.theme.cartType !== 'side_drawer' || !document.getElementById('mini-cart')) return;
    if (busy) {
      pending = true;
      return;
    }

    busy = true;
    pending = false;
    var controller = new AbortController();
    var timeout = setTimeout(function () { controller.abort(); }, 15000);
    var cartUrl = window.routes.cartUrl;
    var separator = cartUrl.indexOf('?') === -1 ? '?' : '&';

    function complete() {
      clearTimeout(timeout);
      busy = false;
      if (pending) refreshMiniCart();
    }

    fetch(cartUrl + separator + 'section_id=mini-cart', {
      credentials: 'same-origin',
      cache: 'no-store',
      signal: controller.signal
    }).then(function (response) {
      if (!response.ok) throw new Error('Mini-cart refresh failed');
      return response.text();
    }).then(function (html) {
      // A newer change needs a fresh response; do not paint the older one.
      if (pending) return;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.getElementById('mini-cart');
      var current = document.getElementById('mini-cart');
      if (!fresh || !current) return;
      var list = current.querySelector('.mini-cart__line-item-list');
      var scrollTop = list ? list.scrollTop : 0;
      current.innerHTML = fresh.innerHTML;
      var count = fresh.getAttribute('data-item-count');
      if (count !== null) {
        current.setAttribute('data-item-count', count);
        document.querySelectorAll('.header__cart-count').forEach(function (badge) {
          badge.textContent = count;
        });
      }
      list = current.querySelector('.mini-cart__line-item-list');
      if (list) list.scrollTop = scrollTop;
    }).then(complete, complete);
  }

  // One listener per event; bubbling events are not registered twice.
  ['product:added', 'cart:refresh', 'cart:productUpdated', 'cart:updated'].forEach(function (name) {
    document.addEventListener(name, refreshMiniCart);
  });

  window.addEventListener('pageshow', function (event) {
    if (!event.persisted || !window.theme || window.theme.pageType === 'cart') return;
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
      bubbles: true,
      detail: { scrollToTop: false }
    }));
  });
})();
